import { Component, OnInit, OnDestroy } from '@angular/core';
import { CnAiService, AiConfig } from '../challenges_service/cn-ai.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var $: any;
declare var toastr: any;

@Component({
  selector: 'app-cn-ai-config',
  templateUrl: './cn-ai-config.component.html',
  styleUrls: ['./cn-ai-config.component.scss']
})
export class CnAiConfigComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  config: AiConfig;
  availableModels: any[] = [];

  constructor(public aiService: CnAiService) {}

  ngOnInit() {
    this.aiService.config$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(config => {
      this.config = { ...config };
      this.availableModels = this.aiService.getModelsForProvider(config.provider);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  saveConfig() {
    this.aiService.saveConfig(this.config);
    this.closeModal();
    toastr.options = { closeButton: true, progressBar: true, timeOut: 2000 };
    toastr.success('AI configuration saved for this session.', 'Saved!');
  }

  openModal() {
    $('.cn-ai-config-modal').css('display', 'flex');
  }

  closeModal() {
    $('.cn-ai-config-modal').css('display', 'none');
  }
}
